import React, { useState, useEffect } from "react";
import { css } from "@emotion/react";
import { CometChat } from "@cometchat-pro/chat";

// mui
import { grey } from "@mui/material/colors";
import Box from "@mui/material/Box";
import Divider from "@mui/material/Divider";
import Typography from "@mui/material/Typography";

const style = {
  root: css`
    margin-bottom: 8px;
  `,
  members: css`
    color: ${grey[500]};
    cursor: pointer;
  `,
};

type MessageListHeaderProps = {
  group: CometChat.Group;
};
const MessageListHeader: React.FC<MessageListHeaderProps> = (props) => {
  const { group } = props;
  const [members, setMembers] = useState<CometChat.User[]>([]);
  const [showMembers, setShowMembers] = useState(false);

  const toggleMembers = () => setShowMembers(!showMembers);

  // https://www.cometchat.com/docs/javascript-chat-sdk/groups-retrieve-group-members
  const fetchMembers = () => {
    const limit = 30;
    const groupMembersRequest = new CometChat.GroupMembersRequestBuilder(group.getGuid()).setLimit(limit).build();
    groupMembersRequest.fetchNext().then(
      (groupMembers: CometChat.User[]) => {
        setMembers(groupMembers);
      },
      (error: any) => {
        console.log("Group Member list fetching failed with exception:", error);
      },
    );
  };

  useEffect(() => {
    fetchMembers();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [group]);

  return (
    <Box css={style.root}>
      <Typography variant="h6">{group.getName()}</Typography>
      <Typography variant="subtitle1" gutterBottom css={style.members} onClick={toggleMembers}>
        {group.getMembersCount()} members
      </Typography>

      {showMembers && members.map((member, idx) => <div key={idx}>{member.getName()}</div>)}
      <Divider />
    </Box>
  );
};

export default MessageListHeader;
